import { apiRequest } from "./common";

const getNotificationCount = async (userId) => {
    const response = await apiRequest('get', `/notification/unread-count?user_id=${userId}`);
    return response.data;
};

const getNotification = async (userId, pageNo, type, startDate, endData) => {
    const response = await apiRequest('get', `/notification/own?user_id=${userId}&page=${pageNo}&limit=20${type ? `&type=${type}` : ''}${startDate ? `&start_date=${startDate}` : ''} ${endData ? `&end_date=${endData}` : ''}`);
    return response.data;
};

const getNotificationStat = async () => {
    const response = await apiRequest('get', `/notification/stats`);
    return response.data;
};

const getAllNotification = async (userId, priority) => {
    const response = await apiRequest('get', `/notification/own/all?user_id=${userId}${priority ? `&priority=${priority}` : ''}`);
    return response.data;
};

const markNotificationRead = async (data) => {
    const response = await apiRequest('post', `/notification/mark-read`, data);
    return response.data;
};

export {
    getNotificationCount,
    getNotification,
    getNotificationStat,
    getAllNotification,
    markNotificationRead
};
